/**
 * Eсли на vkBridge прислал нижний инсет больше обычного,
 * это является косвенным признаком что открылась клавиатура.
 * В этом случае inset.bottom харарктеризует не нижний инсет, а высоту клавиатуры.
 * Исторические особенности реализации vkBridge.
 */
export const IOS_KEYBOARD_OPENED_MIN_BOTTOM_INSET = 150;

export const KEYBOARD_ACTIVE_TAGS = ['INPUT', 'TEXTAREA'];
